import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback, useMemo, } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useDebounce } from 'Shared/hooks';
import { MULTISELECT_FILTERING_DELAY } from 'Common/consts';
import { getResetButtonStatus } from 'Common/utils';
import { setFiltersPLR } from 'PhenotypeView/store/slice';
import { getFiltersData, getIsFiltering } from 'PhenotypeView/store/selectors/levelResults/plr/plr';
import Filters from './Filters';
const FiltersContainer = ({ exportedHeaders, getBinaryPlotDataPointShape, getContinuousPlotDataPointShape, filtersSectionRef, hasStickyShadow, }) => {
    const { filters, phenotypes, categories, } = useSelector(getFiltersData);
    const { phenotype } = filters;
    const isFiltering = useSelector(getIsFiltering);
    const dispatch = useDispatch();
    const handleCategoriesChange = useCallback((updatedCategories) => {
        dispatch(setFiltersPLR({ categories: updatedCategories }));
    }, [dispatch]);
    const handleCategoriesChangeDebounced = useDebounce(handleCategoriesChange, MULTISELECT_FILTERING_DELAY);
    const handleMaxPValueChange = useCallback((updatedValue) => {
        dispatch(setFiltersPLR({ maxPValue: updatedValue }));
    }, [dispatch]);
    const handlePhenotypeChange = useCallback((updatedValue) => {
        if (updatedValue !== phenotype) {
            dispatch(setFiltersPLR({ phenotype: updatedValue }));
        }
    }, [phenotype, dispatch]);
    const handleReset = useCallback(() => {
        dispatch(setFiltersPLR({
            categories,
            maxPValue: null,
            phenotype: null,
        }));
    }, [categories, dispatch]);
    const isFiltersNotChanged = useMemo(() => getResetButtonStatus(filters, null, categories), [categories, filters]);
    return (_jsx(Filters, { sectionRef: filtersSectionRef, categories: categories, phenotypes: phenotypes, filters: filters, onCategoriesChange: handleCategoriesChangeDebounced, onMaxPValueChange: handleMaxPValueChange, onPhenotypeChange: handlePhenotypeChange, exportedHeaders: exportedHeaders, getBinaryPlotDataPointShape: getBinaryPlotDataPointShape, getContinuousPlotDataPointShape: getContinuousPlotDataPointShape, disabled: isFiltering, hasStickyShadow: hasStickyShadow, resetFilters: handleReset, isFiltersNotChanged: isFiltersNotChanged }, void 0));
};
export default memo(FiltersContainer);
